module.exports = __webpack_public_path__ + "static/christmas_bible_read.c0023150.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project3/christmas_bible_read.jpg
// module id = 501
// module chunks = 142966368958528